var _a;
import { getAllActions } from "../generic/all.actions";
import { createRoutine } from "../utils/routine.utils";
import CONFIG from "./invoice.config";
export var getDetail = (_a = getAllActions({
    entityName: CONFIG.ENTITY_NAME,
}), _a.getDetail), getPaged = _a.getPaged;
export var markInvoicePaid = createRoutine("INVOICE_MARK_PAID");
export var markInvoiceUnpaid = createRoutine("INVOICE_MARK_UNPAID");
